import React, { Suspense } from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { ThemeProvider } from '@mui/material';

import { AppLayout } from 'layouts';
import { Loading } from 'pages';

import { theme } from 'theme';

import 'styles/common.scss';

import { store } from './store';

function App() {
    return (
        <ThemeProvider theme={theme}>
            <ReduxProvider store={store}>
                <Suspense fallback={<Loading />}>
                    <AppLayout />
                </Suspense>
            </ReduxProvider>
        </ThemeProvider>
    );
}

export default App;
